import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/facilities/$facilityKey/residents/$userKey/assessments/registration",
)({
  beforeLoad({ params, search }) {
    // 過去に使用されていたルートを最新のルートにリダイレクトする。
    throw redirect({
      params,
      search,
      to: "/facilities/$facilityKey/residents/$userKey/independence-levels/registration",
    });
  },
});
